import './vendor/polyfill/array-from'
import { beamPageLoad } from 'js/services/tagularEvent'

let brokerCtas = Array.from(document.querySelectorAll('[data-product-click]'))

/* Handle ProductClicked Event */
brokerCtas.forEach(cta => {
  cta.onclick = function() {
    beamPageLoad(
      'ProductClicked',
      {
        product: {
          productId: null, // will ultimately need to change from null once Products become monetizable
          category: cta.getAttribute('data-category'),
          brand: cta.getAttribute('data-brand'),
          position: parseInt(cta.getAttribute('data-ctaposition'), 10),
          location: cta.getAttribute('data-location')
        },
        correlationId: window.purchaseId
      },
      'ecommerce',
      'v1'
    )
  }
})

let reviewLinks = Array.from(document.querySelectorAll('[data-element-click]'))

/* Handle ElementClicked Event */
reviewLinks.forEach(link => {
  link.onclick = function() {
    beamPageLoad(
      'ElementClicked',
      {
        webElement: {
          location: link.getAttribute('data-location'),
          position: link.getAttribute('data-ctaposition'),
          elementType: link.getAttribute('data-element-type'),
          text: link.getAttribute('data-brand').trim()
        },
        actionOutcome: link.getAttribute('data-action-outcome')
      },
      'usertracking',
      'v3'
    )
  }
})

let accordion = document.getElementById('author-accordion')
if (accordion) {
  let accordionToggle = accordion.getElementsByTagName('button')

  accordionToggle[0].onclick = function() {
    let parent = this.parentElement
    let accordionContent = parent.nextElementSibling
    parent.classList.contains('--is-active')
      ? parent.classList.remove('--is-active')
      : parent.classList.add('--is-active')
    accordionContent.classList.contains('+display-none')
      ? accordionContent.classList.remove('+display-none')
      : accordionContent.classList.add('+display-none')
  }
}

function hideTooltipBoxes() {
  Array.from(document.querySelectorAll('.tooltip__box')).forEach(box => {
    box.style.display = 'none'
  })
}

let tooltips = Array.from(document.querySelectorAll('.tooltip'))

tooltips.forEach(tooltip => {
  tooltip.onclick = function(e) {
    const box = this.querySelector('.tooltip__box')
    const state = box.style.display
    hideTooltipBoxes()
    box.style.display = state === 'block' ? 'none' : 'block'
    e.stopPropagation()
  }
})

document.body.onclick = hideTooltipBoxes
